const util = {
    lastItem : (arr) => {
        return arr[ arr.length -1 ];
    },
    isObject : ( el ) => {
        return typeof el === 'object' && !Array.isArray(el) && el !== null;
    },
    iOS : () => {
            return [
              'iPad Simulator',
              'iPhone Simulator',
              'iPod Simulator',
              'iPad',
              'iPhone',
              'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    },
    isTouchDevice : () => {
        return (('ontouchstart' in window) ||
             (navigator.maxTouchPoints > 0) ||
             (navigator.msMaxTouchPoints > 0));
    }
}

module.exports = util;